export const CustomerConstant = {
  modalCustomerAdquirer: {
    title:
      'Este es un cliente nuevo, ¿Deseas consultar el nombre y correo del cliente?.',
    description:
      'Recuerda que al aceptar, se buscará en la base de datos de la DIAN la información del cliente.',
  },
  modalCustomerSearch: {
    succes: (nombrecliente, correo, tipopersona) =>
      `<div style="font-size: 16px;  padding: 5px;">

            <div style="text-align: center;">
                <strong style="color: #a2e3a4; font-size: 18px; letter-spacing: 0.5px;">Consulta Exitosa</strong>
            </div>

             <div style="margin-top: 25px; text-align: center; padding: 10px;">
                <p style="margin: 0; font-style: italic; font-size: 15px; color: #FFFF; text-align: left;">
                    ¿Desea actualizar los datos del formulario, con la siguiente información del cliente?
                </p>
            </div>
            
            <div style="border-radius: 8px; margin:10px 0 0 10px;">
                <div style="margin-bottom: 18px; text-align: left;">
                    <p style="margin: 0 0 6px 0;">
                        <strong style="color: #7dd1f8; font-size: 15px;">${
                          tipopersona === '1'
                            ? 'Razón Social:'
                            : 'Nombre y Apellido:'
                        }</strong>
                    </p>
                    <p style="margin: 0; font-weight: 100; font-size: 14px; color: #FFFF;">
                        ${nombrecliente}
                    </p>
                </div>
                    
                <div style="margin-bottom: 10px; text-align: left;">
                    <p style="margin: 0 0 6px 0;">
                        <strong style="color: #7dd1f8; font-size: 15px;">Correo electrónico:</strong>
                    </p>
                    <p style="margin: 0; font-weight: 100; font-size: 14px; color: #f0f0f0;">
                        ${correo}
                    </p>
                </div>
            </div>

        </div>`,
    messageNotFoundTitle: 'Documento no encontrado',
    messageNotFound:
      'No se encontró información asociado a ese numero de documento.',
  },
  buttonModal: {
    confirm: 'Confirmar',
    accept: 'Aceptar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    search: 'Consultar en la DIAN',
    update: 'Actualizar datos',
    manual: 'Seguir manualmente',
    save: 'Guardar',
  },
};
